function forceDownload(blob: string, filename: string) {
  const a = document.createElement('a');
  a.target = '_blank';
  a.download = filename;
  a.href = blob;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

// supports downloading a PDF resource across browsers
export async function downloadResource(
  url: string | undefined,
  filename: string | undefined,
) {
  if (!url || !filename) {
    return;
  }

  const response = await fetch(url, {
    headers: new Headers({
      Origin: location.origin,
    }),
    mode: 'cors',
  });

  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  try {
    forceDownload(blobUrl, filename);
  } catch (e) {
    console.error(e);
  }
}
